// extracted by mini-css-extract-plugin
export default {"card":"QuestionCard_card__VyNAL","cardTitle":"QuestionCard_cardTitle__7Y-It"};